import { ArticleHeading2, ArticleHeading3, ArticleParagraph1, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { IUtpItemWithImage } from 'shared/types/utp';
import { useSelector } from 'react-redux';
import { selectMortrageInfo } from 'shared/selectors/selectMortrageInfo';

type THowItWorksProps = IUtpItemWithImage;

export const HowItWorks: React.FC<THowItWorksProps> = ({ id, title, descr, imageClass }) => {
  const device = useDeviceType();

  const mortrageInfo = useSelector(selectMortrageInfo);

  const { objectPriceRateDiscount, mortgageRateDiscount } = mortrageInfo;

  const isPhone = device === 'phone';

  const Title = isPhone ? ArticleHeading3 : ArticleHeading2;

  const Description = isPhone ? ArticleParagraph2 : ArticleParagraph1;

  return (
    <div className={clsx(style['item'], style[device])}>
      <div className={style['text-block']}>
        <div className={style['item-title']}>
          <Title>
            {id === 1 ? 'Вы договариваетесь с собственником о скидке ' + objectPriceRateDiscount + '%' : title}
          </Title>
        </div>
        <div className={style['item-descr']}>
          <Description>
            {id === 1
              ? 'Покупатель заплатит эту сумму банку как комиссию за снижение ставки на ' + mortgageRateDiscount + '%'
              : descr}
          </Description>
        </div>
      </div>
      <div className={clsx(style['item-image'], style[imageClass])} />
    </div>
  );
};
